import 'waypoints/lib/noframework.waypoints.min';
import clickOutside from './click-outside';

document.addEventListener('DOMContentLoaded', () => {
  // Nav toggler (hamburger button)
  const navToggler = document.querySelector('.js-nav-toggler');
  navToggler.addEventListener('click', () => {
    navToggler.classList.toggle('active');
  });

  // Toggle mobile/tablet nav height
  const navContainer = document.querySelector('.js-nav-ul');
  document
    .querySelector('.js-nav-toggler')
    .addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (navContainer.classList.contains('active')) {
        navContainer.classList.remove('active');
      } else {
        navContainer.classList.add('active');
      }
    });
  document.addEventListener('click', () => {
    navContainer.classList.remove('active');
    navToggler.classList.remove('active');
  });

  // Hide/show/duplicate subnav menus
  const subnavToggles = document.querySelectorAll('.js-subnav-toggle');
  const megamenuToggles = document.querySelectorAll('.js-megamenu-toggle');
  const navBreakpoint = 992; // 992px is the Bootstrap 'Large devices' breakpoint

  // Mega menu mobile
  megamenuToggles.forEach((megamenuToggle) => {
    // Duplicate parent links as overview links
    if (window.innerWidth <= navBreakpoint) {
      // The list for this nav item to be inserted into
      const childList = megamenuToggle.nextElementSibling;

      // Generate the link to be inserted
      const parentLink = document.createElement('A');
      parentLink.innerHTML = megamenuToggle.innerHTML;
      parentLink.setAttribute('href', megamenuToggle.getAttribute('href'));
      parentLink.classList.add('nav-megamenu-link');
      childList.insertBefore(parentLink, childList.firstChild);
    }

    // Toggle mega menu mobile menus
    megamenuToggle.addEventListener('click', (event) => {
      if (window.innerWidth <= navBreakpoint) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target.classList.contains('active')) {
          event.target.classList.remove('active');
        } else {
          document
            .querySelectorAll('.nav-megamenu-section-name')
            .forEach((item) => {
              item.classList.remove('active');
            });
          event.target.classList.add('active');
        }
      }
    });
  });

  // Close hamburger nav on clicking subnav links
  const subnavLinks = document.querySelectorAll(
    '.nav-subnav-link, .nav-megamenu-link'
  );
  subnavLinks.forEach((subnavLink) => {
    subnavLink.addEventListener('click', () => {
      if (window.innerWidth <= navBreakpoint) {
        navContainer.classList.remove('active');
        navToggler.classList.remove('active');
      }
    });
  });

  const hideAllSubnavToggles = () => {
    subnavToggles.forEach((subnavToggle) => {
      subnavToggle.classList.remove('active');
    });
  };

  subnavToggles.forEach((subnavToggle) => {
    subnavToggle.addEventListener('click', (event) => {
      // prevent default on top level nav items with subnav
      if (event.target.classList.contains('nav-link')) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (
        subnavToggle.classList.contains('active') &&
        !event.target.closest('.nav-megamenu')
      ) {
        // Hide subnav
        subnavToggle.classList.remove('active');
      } else {
        hideAllSubnavToggles();
        // Show subnav
        subnavToggle.classList.add('active');

        const removeClickOutside = clickOutside(subnavToggle, () => {
          subnavToggle.classList.remove('active');
          removeClickOutside();
        });
      }
    });
  });

  if (document.querySelector('body.page-has-transparent-header')) {
    new Waypoint({
      element: document.querySelector('[data-header-waypoint]'),
      handler: (direction) => {
        if (direction === 'down') {
          if (!document.querySelector('.header').style.backgroundColor) {
            document
              .querySelector('.header')
              .classList.remove('transparent-header');
          }
        } else {
          document.querySelector('.header').classList.add('transparent-header');
        }
      },
      offset: 100,
    });
  }
});
